export function buildZaagplanDisplaySheets(layout, sourcePanel) {
  const activeSheets = layout?.sheets || [];
  const virtualSheets = (layout?.unusedRestStock || []).map((item, index) => ({
    index: activeSheets.length + index,
    source: "rest",
    unused: true,
    unusedReason: item.reason,
    unusedMessage: item.message,
    thickness: item.thickness,
    sheetLength: item.length,
    sheetWidth: item.width,
    margin: sourcePanel?.margin || 0,
    restStockLabel: item.label,
    restStockId: item.restStockId,
    restStockOccurrence: item.occurrence,
    placements: [],
    thicknessSheetIndex: 0,
  }));

  return [...activeSheets, ...virtualSheets];
}
